import script from "./NewsPageStoryButton.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageStoryButton.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageStoryButton.vue?vue&type=style&index=0&id=43ee55d8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ee55d8"]])

export default __exports__